var FRONT_COVER_TYPE_VALUE = "01";
var IMAGE_MODE_VALUE = "03";
/**
 * ONIX Codetable 15 value of the main (distinctive) title name. A title record
 * must contain exactly one name of this type.
 */
export var MAIN_NAME_TYPE_VALUE = "01";
export var getTitleCoverUrl = function (resources) {
    if (!resources) {
        return null;
    }
    var cover = resources.find(function (resource) {
        var _a, _b, _c;
        return ((_a = resource.type) === null || _a === void 0 ? void 0 : _a.value) === FRONT_COVER_TYPE_VALUE &&
            ((_b = resource.mode) === null || _b === void 0 ? void 0 : _b.value) === IMAGE_MODE_VALUE &&
            !!((_c = resource.link) === null || _c === void 0 ? void 0 : _c.trim());
    });
    return (cover === null || cover === void 0 ? void 0 : cover.link) || null;
};
export var getMainTitleName = function (names) {
    if (!names || names.length === 0) {
        return null;
    }
    return (names.find(function (name) { var _a; return ((_a = name.type) === null || _a === void 0 ? void 0 : _a.value) === MAIN_NAME_TYPE_VALUE; }) || names[0]);
};
export var getContributionDisplayName = function (contribution) {
    var _a;
    if (contribution.firstName || contribution.lastName) {
        return "".concat(contribution.firstName || "", " ").concat(contribution.lastName || "").trim();
    }
    return ((_a = contribution.unnamedPerson) === null || _a === void 0 ? void 0 : _a.description) || contribution.name || "";
};
